import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useCallback, useEffect, useMemo } from 'react';
import { ConnectedUserSearch } from '~/views/organisms/search/connected-user-search/connected.user.search';
import { VisitorSearch } from '~/views/organisms/search/visitor-search/visitor.search';
import { SimpleSearch } from '~/views/organisms/search/simple-search/simple.search';
import { useService } from '~/services/service.base';
import { AuthService } from '~/services/service.auth';
import { MediaSearchService } from '~/services/service.media.search';
import { Dialog, Slide } from '@mui/material';
import { ServicePaginator } from '~/services/service.paginator';
import { reaction } from 'mobx';
const Transition = forwardRef(function Transition(props, ref) {
    return _jsx(Slide, { direction: "up", ref: ref, ...props });
});
export const useSearchForm = () => {
    const auth = useService(AuthService);
    const mediaSearchService = useService(MediaSearchService);
    const { openSearchSvc } = mediaSearchService;
    const servicePaginator = useService(ServicePaginator);
    const getSearchForm = useCallback(() => {
        if (openSearchSvc.open && auth.isLogged) {
            return _jsx(ConnectedUserSearch, {});
        }
        else if (openSearchSvc.open && !auth.isLogged) {
            return _jsx(VisitorSearch, {});
        }
        else {
            return _jsx(SimpleSearch, {});
        }
    }, [auth.isLogged, openSearchSvc.open]);
    const searchForm = useMemo(() => (_jsx(Dialog, { fullScreen: true, open: mediaSearchService.openDialogSvc.open, TransitionComponent: Transition, children: getSearchForm() })), [getSearchForm, mediaSearchService.openDialogSvc.open]);
    useEffect(() => {
        return reaction(() => servicePaginator.paginatorData.offset, offset => {
            if (Number(offset) > 0) {
                mediaSearchService.getMediaItems({ ...servicePaginator.paginatorData, offset });
            }
        });
    }, [mediaSearchService, servicePaginator.paginatorData]);
    return searchForm;
};
